import { render, staticRenderFns } from "./WordEvaluateModel.vue?vue&type=template&id=27f821f8&scoped=true"
import script from "./WordEvaluateModel.vue?vue&type=script&lang=js"
export * from "./WordEvaluateModel.vue?vue&type=script&lang=js"
import style0 from "./WordEvaluateModel.vue?vue&type=style&index=0&id=27f821f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f821f8",
  null
  
)

export default component.exports